import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminMenuComponent } from './menu/menu.component';
import { RouterModule } from '@angular/router';
import { AdminLayoutComponent } from './layout/layout.component';
import { DashlayoutComponent } from './dashlayout/dashlayout.component';
import { FooterComponent } from './dashlayout/footer/footer.component';
import { HeaderComponent } from './dashlayout/header/header.component';
import { SidebarComponent } from './dashlayout/sidebar/sidebar.component';
import { SettingsComponent } from './dashlayout/settings/settings.component';
import { MenuComponent } from './dashlayout/sidebar/menu/menu.component';
import { NotificationsComponent } from './dashlayout/header/notifications/notifications.component';
import { MessageComponent } from './dashlayout/header/message/message.component';
import { GreyscaleComponent } from './dashlayout/header/greyscale/greyscale.component';
import { TogglethemeComponent } from './dashlayout/header/toggletheme/toggletheme.component';
import { LanguageComponent } from './dashlayout/header/language/language.component';
import { ProfileComponent } from './dashlayout/header/profile/profile.component';



@NgModule({
  declarations: [AdminMenuComponent,AdminLayoutComponent, DashlayoutComponent, FooterComponent, HeaderComponent, SidebarComponent, SettingsComponent, MenuComponent, NotificationsComponent, MessageComponent, GreyscaleComponent, TogglethemeComponent, LanguageComponent, ProfileComponent],
  exports: [AdminMenuComponent,AdminLayoutComponent,DashlayoutComponent],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class AdminSharedModule { }
